import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { useAuth } from "./AuthContext";

const inputCls = "mt-1 h-11 w-full rounded-xl border border-white/10 bg-black/40 px-3 text-sm text-stone-100 outline-none focus:border-orange-500";

export const ChangePassword = ({ onDone }) => {
  const { setUser } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.new_password !== f.confirm) { setError("The new passwords don't match."); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password changed. Other sessions have been signed out.");
      setUser(data);
      onDone?.();
    } catch (err) { setError(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="space-y-3 rounded-2xl border border-white/10 bg-[#141110] p-5" data-testid="change-password-form">
      <label className="block text-xs text-stone-400">Current password
        <input type="password" autoComplete="current-password" value={f.current_password} onChange={set("current_password")} className={inputCls} data-testid="change-password-current" />
      </label>
      <label className="block text-xs text-stone-400">New password
        <input type="password" autoComplete="new-password" value={f.new_password} onChange={set("new_password")} className={inputCls} data-testid="change-password-new" />
        <span className="mt-1 block text-[11px] text-stone-500">At least 12 characters with letters and numbers. Avoid your name, email or common words.</span>
      </label>
      <label className="block text-xs text-stone-400">Confirm new password
        <input type="password" autoComplete="new-password" value={f.confirm} onChange={set("confirm")} className={inputCls} data-testid="change-password-confirm" />
      </label>
      {error && <p role="alert" className="rounded-lg border border-red-400/30 bg-red-500/10 px-3 py-2 text-xs text-red-200" data-testid="change-password-error">{error}</p>}
      <button type="submit" disabled={busy} className="tc-btn-primary inline-flex h-11 items-center gap-2 rounded-full px-6 text-sm font-semibold" data-testid="change-password-submit">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} Change password
      </button>
    </form>
  );
};
